import React, { useState } from 'react';
import { COGGINS_ACCEPT, openHorseCogginsDocument } from '../../utils/horseCareApi.ts';

interface CogginsUploadFieldProps {
  horseId?: string;
  existingUrl?: string | null;
  existingFileName?: string | null;
  selectedFile: File | null;
  onFileChange: (file: File | null) => void;
  onRemoveExisting?: () => void;
  removeExistingPending?: boolean;
  disabled?: boolean;
}

export default function CogginsUploadField({
  horseId,
  existingUrl,
  existingFileName,
  selectedFile,
  onFileChange,
  onRemoveExisting,
  removeExistingPending,
  disabled
}: CogginsUploadFieldProps) {
  const [opening, setOpening] = useState(false);

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">Coggins certificate</label>
      <p className="text-xs text-gray-500">PDF or photo (JPEG, PNG, HEIC from iPhone)</p>

      {existingUrl && !selectedFile && (
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200">
          {horseId ? (
            <button
              type="button"
              disabled={opening || disabled}
              onClick={async () => {
                setOpening(true);
                try {
                  await openHorseCogginsDocument(horseId);
                } finally {
                  setOpening(false);
                }
              }}
              className="text-sm text-ggaa-green font-medium break-all hover:underline flex-1 min-h-[44px] flex items-center text-left disabled:opacity-60"
            >
              {opening ? 'Opening…' : existingFileName || 'View current Coggins'}
            </button>
          ) : (
            <span className="text-sm text-gray-600 flex-1 min-h-[44px] flex items-center break-all">
              {existingFileName || 'Coggins on file (save horse to view)'}
            </span>
          )}
          {onRemoveExisting && (
            <button
              type="button"
              onClick={onRemoveExisting}
              disabled={disabled || removeExistingPending}
              className="text-sm text-red-600 hover:text-red-800 min-h-[44px] px-3 disabled:opacity-50"
            >
              {removeExistingPending ? 'Removing…' : 'Remove'}
            </button>
          )}
        </div>
      )}

      <input
        type="file"
        accept={COGGINS_ACCEPT}
        disabled={disabled}
        onChange={(e) => onFileChange(e.target.files?.[0] || null)}
        className="block w-full text-sm text-gray-600 file:mr-3 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-ggaa-green file:text-white hover:file:bg-ggaa-green/90 min-h-[44px]"
      />

      {selectedFile && (
        <p className="text-xs text-gray-600 break-all">Selected: {selectedFile.name}</p>
      )}
    </div>
  );
}
